import React from "react";
import { useTranslation } from "react-i18next";
import { IconLeaf, IconPillFilled } from "@tabler/icons-react";
import MDialog from "@/components/ui/atoms/MDialog";
import { MedicineItemType, PillboxItem } from "@/types/pillbox";
import {
  formatFrequencyLine,
  formatMedicineTitle,
} from "../utils/formatMedicine";
import styles from "./DuplicateMedicineModal.module.css";

export interface DuplicateMedicineModalProps {
  open: boolean;
  item: PillboxItem;
  variant: "active" | "past";
  memberDisplayName: string;
  onClose: () => void;
  onConfirm: () => void;
}

const DuplicateMedicineModal: React.FC<DuplicateMedicineModalProps> = ({
  open,
  item,
  variant,
  memberDisplayName,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const isSupplement = item.itemType === MedicineItemType.SUPPLEMENT;

  return (
    <MDialog
      isOpen={open}
      onClose={onClose}
      title={t("pillbox.duplicateModal.title", {
        member: memberDisplayName,
      })}
      description={t(
        variant === "active"
          ? "pillbox.duplicateModal.bodyActive"
          : "pillbox.duplicateModal.bodyPast"
      )}
      primaryCtaText={t(
        variant === "active"
          ? "pillbox.duplicateModal.editButton"
          : "pillbox.duplicateModal.restoreButton"
      )}
      onPrimaryCta={onConfirm}
    >
      <div className={styles.previewCard}>
        <span className={styles.iconBox}>
          {isSupplement ? (
            <IconLeaf size={24} stroke={1.5} color="#45168C" />
          ) : (
            <IconPillFilled size={24} color="#45168C" />
          )}
        </span>
        <span className={styles.content}>
          <span className={styles.title}>{formatMedicineTitle(item)}</span>
          <span className={styles.frequencyLine}>
            {formatFrequencyLine(item, item.recurrenceIntervalDays)}
          </span>
        </span>
      </div>
    </MDialog>
  );
};

export default DuplicateMedicineModal;
